import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as apiAppointment from '../../services/ApiAppointment'
import Loader from "../../components/Loader";
import { Box, Tooltip, IconButton, FormControl, MenuItem, Select } from "@mui/material";
import { notifyError } from '../../components/NotifyToast'

import AddAppointment from "./AddAppointment";

import { IoArrowBackOutline } from "react-icons/io5";
import { IoMdAddCircleOutline } from "react-icons/io";

import { MdHourglassEmpty } from "react-icons/md";
import { MdCheckCircle } from "react-icons/md";
import { MdDoneAll } from "react-icons/md";
import { IoVideocam } from "react-icons/io5";

import { config } from '../../config.env';

export default function AppointmentList() {

    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);

    const [addPage, setAddPage] = useState(false);

    const [hospital, setHospital] = useState('')
    const [optionHospital, setOptionHospital] = useState([])
    const [date, setDate] = useState('')
    const [optionDate, setOptionDate] = useState([])

    const [appointment, setAppointment] = useState([])
    const [showList, setShowList] = useState([])


    useEffect(() => {
        setDate('')
    }, [hospital])

    useEffect(() => {
        if (hospital === '' || hospital === ' ') {
            if (date === '' || date === ' ') {
                findAppointment()
            } else {
                filterDateData()
            }
        } else {
            if (date === '' || date === ' ') {
                filterHospitalData()
            } else {
                filterDateData()
            }
        }
    }, [date, hospital])


    const findAppointment = async () => {

        setLoading(true);
        
        const now = Date.now();
        //const now = Date.parse("2025-06-26T13:10:00Z");
        const lastYear = new Date(now-31536000000).toISOString().slice(0, 10);
        const nextYear = new Date(now+31536000000).toISOString().slice(0, 10);
        let res = await apiAppointment.appointmentList(lastYear,nextYear);

        setLoading(false);

        // MockUp
        if ((!res || !res['data']['status']) && !config.PRODUCTION)
        {
            console.log("Mockup Appointments");
            res = {
                data: {
                    status: true,
                    data: [
                    ]
                }
            };

            const status = ['N','W','S','C'];
            const n = Math.round(Math.random()*8);
            for (let i=0; i<n; i++)
            {
                res['data']['data'].push({
                    appointment_status: status[Math.round(Math.random()*3)],
                    appointment_date: `2025-07-${(1+Math.round(Math.random()*29)).toString().padStart(2,'0')}`,
                    appointment_time: `${(8+Math.round(Math.random()*12)).toString().padStart(2,'0')}:${(Math.round(Math.random()*5)*10).toString().padStart(2,'0')}:00`,
                    hospital_code: '00000',
                    hospital_name: 'รพ.ทดสอบ',
                    department_name: 'แผนกทดสอบ',
                    doctor_name: 'หมอไม่พร้อม',
                });
            }
        }

        if (res) {
            if (res['data']['status'] === true) {

                const colors = {
                    N: '#fff9e6',
                    W: '#e6f2ff',
                    S: '#ecffe6',
                    C: '#e6eaff'
                };

                const resData = res['data']['data'];
                const data = [];
                for (let i = 0; i < resData.length; i++) {

                    const apm = resData[i];
                    if (!apm)
                        continue;

                    let status = apm['appointment_status'];

                    const apmTime = +(new Date(`${apm.appointment_date}T${apm.appointment_time}`));
                    const timeDiff = (now - apmTime)/60000;

                    // Conference ready; if within 5 mins before or 30 mins after appointment time
                    if (status === 'W' && timeDiff >= -5 && timeDiff <= 30)
                    {
                        apm['appointment_status'] = 'C';
                        status = 'C';
                    }
                    // For past appointments, only include completed ones
                    else if (timeDiff > 30 && status !== 'S')
                        continue;

                    apm['status_col'] = colors[status] ? colors[status] : '#E3E9F2';

                    data.push(apm)
                }

                // Unconfirmed and confirmed appointments are placed together first, later ordered last
                // Completed appointments are placed later, recent ordered first
                data.sort((a,b) => {

                    const timeA = a.appointment_date + a.appointment_time;
                    const timeB = b.appointment_date + b.appointment_time;
                    const timeComp = timeA.localeCompare(timeB);

                    if (a.appointment_status === 'S' && b.appointment_status === 'S')
                        return -timeComp;
                    else if (a.appointment_status === 'S' || b.appointment_status === 'S')
                    {
                        if (a.appointment_status === 'S')
                            return 1;
                        else return -1; 
                    }
                    else return timeComp;
                })

                setAppointment(data);
                setShowList(data);

                prepHospitalOption(data);
                prepDateOption(data);

            } else {
                if (res['data']['message'] === "ไม่พบข้อมูล") {
                    console.log(res['data']['message'])
                } else {
                    notifyError(res['data']['message'])
                }
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    const prepHospitalOption = (data) => {
        let option = []
        for (let i = 0; i < data.length; i++) {
            if (data[i]) {
                option.push({
                    key: data[i]['hospital_code'],
                    value: data[i]['hospital_name']
                })
            }
        }
        const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
        setOptionHospital(unique)
    }

    const prepDateOption = (data) => {
        let option = []
        for (let i = 0; i < data.length; i++) {
            if (data[i]) {
                option.push(data[i]['appointment_date'])
            }
        }
        const unique = [...new Map(option.map((m) => [m, m])).values()] //กรองชื่อซ้ำ
        setOptionDate(unique)
    }

    const filterHospitalData = () => {
        const List = []
        for (let i = 0; i < appointment.length; i++) {
            if (appointment[i]['hospital_code'] === hospital) {
                List.push(appointment[i])
            }
        }
        setShowList(List)

        prepDateOption(List);
    }

    const filterDateData = () => {
        const List = []
        for (let i = 0; i < appointment.length; i++) {
            if (appointment[i]['appointment_date'] === date) {
                List.push(appointment[i])
            }
        }
        setShowList(List)
    }


    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <>
            {loading && <Loader loading={loading} />}

            <Box sx={{
                color: '#263238',
                display: 'flex',
                flexDirection: 'column',
                fontSize: 18,
                gridGap: '0.5em',
                m: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
                '@media (max-width: 1023px)': { fontSize: 16, },
                '@media (max-width: 800px)': { fontSize: 14, },
                '@media (orientation: portrait)': { fontSize: '6vw', gridGap: '0.33em' },
            }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    mb:2,
                    '@media (orientation: portrait)': {
                        gridTemplateColumns: '1fr 3fr 1fr',
                        '@media (min-width: 1000px)': {
                            m: '1em',
                        },
                    }
                }}>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        ml: '3rem',
                        '@media (orientation: portrait)': {
                            ml: 0,
                        }
                    }}>
                        <Tooltip title="ย้อนกลับ">
                            <IconButton onClick={() => { navigate('/mainMenu') }} aria-label="Back" color="c_button" variant="resp">
                                <IoArrowBackOutline size='1.25em'/>
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{
                        textAlign: 'center',
                        alignSelf: 'end',
                        color: 'c_title.main',
                        '@media (orientation: portrait)': {
                            alignSelf: 'center',
                        }
                    }}
                    >{addPage ? "เพิ่มการนัดหมาย" : "รายการนัดหมาย"}</Box>

                    <Box sx={{
                        display: 'inline',
                        justifySelf: 'end',
                        mr: '3rem',
                        '@media (orientation: portrait)': {
                            mr: 0,
                        }
                    }}>
                        
                        {/*
                        <Tooltip title="เพิ่มการนัดหมาย">
                            <IconButton
                                aria-label="Add"
                                color="c_button"
                                variant={addPage ? "resp1" : "resp0"}
                                onClick={() => { setAddPage(!addPage); }}
                            >
                                <IoMdAddCircleOutline size='1.25em'/>
                            </IconButton>
                        </Tooltip>
                        */}
                    </Box>

                </Box>

                { !addPage ?
                    <>
                        <Box sx={{
                            border: 1,
                            borderColor: '#E1E3E9',
                            borderRadius: '0.375em',
                            bgcolor: '#FFF',
                            pb: 2,
                            mb: '1em',
                            '@media (orientation: portrait)': {
                                fontSize: '0.5em',
                            }
                        }}>
                            <Box sx={{
                                color: '#082C91',
                                fontWeight: 700,
                                backgroundColor: '#E3E9F2',
                                borderBottom: '1px solid #E1E3E9',
                                borderRadius: '0.5em',
                                padding: '0.5em 1em'
                            }}>ค้นหา</Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                padding: '1.25em',
                                '@media (orientation: portrait)': {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '0.5em',
                                    justifyItems: 'center',
                                    padding: '0.625em'
                                },
                            }}>
                                <FormControl sx={{ width: '90%', color: '#082C91' }} size="small">
                                    <div style={{ fontWeight: 700 }}>โรงพยาบาลที่เข้ารับบริการ</div>
                                    <Select
                                        value={hospital || ' '}
                                        onChange={(event) => {
                                            const {
                                                target: { value },
                                            } = event;
                                            setHospital(value)
                                        }}
                                        sx={{ fontSize:'1em' }}
                                    >
                                        <MenuItem value=" " sx={{ fontSize:'2em' }}>ทั้งหมด</MenuItem>
                                        {optionHospital.map((item, index) => (
                                            <MenuItem
                                                key={index}
                                                value={item['key']}
                                                sx={{ fontSize:'2em' }}
                                            >
                                                {item['value']}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ width: '90%', color: '#082C91' }} size="small">
                                    <div style={{ fontWeight: 700 }}>ค้นหาวันที่</div>
                                    <Select
                                        value={date || ' '}
                                        onChange={(event) => {
                                            const {
                                                target: { value },
                                            } = event;
                                            setDate(value)
                                        }}
                                        sx={{ fontSize:'1em' }}
                                    >
                                        <MenuItem value=" " sx={{ fontSize:'2em' }}>วันที่ทั้งหมด</MenuItem>
                                        {optionDate.map((item, index) => (
                                            <MenuItem
                                                key={index}
                                                value={item}
                                                sx={{ fontSize:'2em' }}
                                            >
                                                {convertDate(item)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Box>
                        </Box>

                        {showList.map((item, idx) => (
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 14fr',
                                border: 1,
                                borderColor: '#E1E3E9',
                                borderRadius: '0.5em',
                                bgcolor: '#FFF',
                                maxHeight: '400px',
                                '@media (orientation: portrait)': {
                                    fontSize: '0.5em',
                                    gridTemplateColumns: '1fr 4fr',
                                }
                            }} key={idx}>

                                <Box sx={{
                                    borderRadius: '0.5em',
                                    display: 'grid',
                                    gridGap: '1em',
                                    '@media (orientation: portrait)': {
                                        px: '0.5em',
                                        gridGap: '0.5em',
                                    },
                                    backgroundColor: item['status_col']
                                }}>

                                    { item['appointment_status'] === 'N' &&
                                        <Tooltip title="กำลังรอการยืนยัน" followCursor>
                                            <IconButton
                                                aria-label="Waiting"
                                                variant="respSimpStatic"
                                                disableRipple
                                            >
                                                <MdHourglassEmpty size='1em'/>
                                            </IconButton>
                                        </Tooltip>
                                    }

                                    { item['appointment_status'] === 'W' &&
                                        <Tooltip title="การนัดถูกยืนยันแล้ว" followCursor>
                                            <IconButton
                                                aria-label="Confirmed"
                                                variant="respSimpStatic"
                                                disableRipple
                                            >
                                                <MdCheckCircle size='1em'/>
                                            </IconButton>
                                        </Tooltip>
                                    }

                                    { item['appointment_status'] === 'S' &&
                                        <Tooltip title="การนัดเสร็จสิ้น" followCursor>
                                            <IconButton
                                                aria-label="Completed"
                                                variant="respSimpStatic"
                                                disableRipple
                                            >
                                                <MdDoneAll style={{ fontSize: '1em' }}/>
                                            </IconButton>
                                        </Tooltip>
                                    }

                                    { item['appointment_status'] === 'C' &&
                                        <Tooltip title="ไปที่ Telemed Conference" followCursor>
                                            <IconButton
                                                aria-label="Conference"
                                                variant="respSimpStatic"
                                                onClick={() => {navigate('/consult')}}
                                                disableRipple
                                                sx={{
                                                    "&:hover": { color:"#ffe14d" }
                                                }}
                                            >
                                                <IoVideocam size='1.25em'/>
                                            </IconButton>
                                        </Tooltip>
                                    }

                                </Box>

                                <Box sx={{display:'flex', flexDirection:'column', py:'1em', px:'1.5em', gap:'0.5em', color: '#082C91', fontWeight: 500}}>
                                    <div style={{display:'flex', fontSize:'1em'}}>
                                        <Box sx={{ fontWeight: 700 }}>วันที่นัดหมาย</Box>
                                        <Box>{' : '+convertDate(item['appointment_date'])}</Box>
                                    </div>
                                    <div style={{display:'flex', fontSize:'1em'}}>
                                        <Box sx={{ fontWeight: 700 }}>เวลานัดหมาย</Box>
                                        <Box>{' : '+item['appointment_time']}</Box>
                                    </div>
                                    <div style={{display:'flex', fontSize:'0.8em'}}>
                                        <Box>{item['hospital_name']}</Box>
                                    </div>
                                    <div style={{display:'flex', fontSize:'0.8em'}}>
                                        <Box>{item['department_name']}</Box>
                                    </div>
                                    <div style={{display:'flex', fontSize:'0.8em'}}>
                                        <Box>{item['doctor_name']}</Box>
                                    </div>   
                                </Box>
                            </Box>
                        ))}
                    </>
                    :
                    <AddAppointment setAddPage={setAddPage}/>
                }
            </Box>
        </>
    )
}